import React from 'react'
import styled from 'styled-components'
import GlobalRow from './GlobalRow'
import { globalFooters } from '../../../helpers/footers'
import multiples from '../../../helpers/multiples'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 7fr;
  grid-column-gap: 0px;
  border-top: 9px solid #f8f8f8;
  border-bottom: 2px solid #dddddd;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #EEEEEE;
`
const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #dfdfdf;
  padding: 40px 0px;
  text-align: center;
  grid-column-start: 1;
  font-weight: bold;
`
export default class GlobalSegment extends React.Component {
  getBusinessCashflowDataByKey = (key) => {
    const { businesses } = this.props.loan
    const cashflowDataByKey = {}
    for (const business of businesses) {
      cashflowDataByKey[business.name] = business.cashflowData.filter(datum => datum.category === key)
    }
    return cashflowDataByKey
  }
  renderPerBusinessCategory = (category) => {
    const { loan, years } = this.props
    return Object.values(loan.businesses).map(business => {
      const businessGlobalSegment = business.financialReviewSegments.find(segment => segment.key === 'global')
      const { title } = businessGlobalSegment.categories.find(cat => cat.key === category.key)
      return (
        <GlobalRow
          title={title.replace('${Business}', business.name)}
          data={business.cashflowData.filter(datum => datum.category === category.key)}
          years={years}
          key={`${title}-${business.name}`}
        />
      )
    })
  }
  renderRows = () => {
    const { data, years, categories } = this.props
    return categories.map(category => {
      if (category.key in multiples) {
        return this.renderPerBusinessCategory(category)
      } else {
        return (
          <GlobalRow
            key={category.key}
            title={category.title}
            data={data.filter(datum => datum.category === category.key)}
            years={years}
            bold={globalFooters.includes(category.key) ? true : false}
          />
        )
      }
    })
  }
  render() {
    const { title } = this.props
    return (
      <Container>
        <Title>{title}</Title>
        <RowContainer>
          {this.renderRows()}
        </RowContainer>
      </Container>
    )
  }
}